import { Box } from '@mui/material';
import styled from 'styled-components';
import { Typography, colors } from '@leapeasy/ui-kit';
import { getDemoData } from 'utils/helpers';
import { DetailsCard } from 'elements/DetailsCard';

export const TenantDetails = ({ application, isDemo }) => {
  return (
    <Box display="flex" flexDirection="column" gap="10px" padding="24px">
      <Typography variant="h4" style={{ color: colors.purple[900] }}>
        Resident Information
      </Typography>

      <DetailsContainer>
        <RowContainer>
          <DetailsCard
            title="Resident 1"
            value={
              isDemo
                ? getDemoData('tenant-name')
                : application.tenant_1_name
                  ? application.tenant_1_name
                  : 'No Data'
            }
          />
          <DetailsCard
            title="Resident 2"
            value={
              isDemo
                ? getDemoData('tenant-name')
                : application.tenant_2_name
                  ? application.tenant_2_name
                  : 'No Data'
            }
          />
          <DetailsCard
            title="Resident 3"
            value={
              isDemo
                ? getDemoData('tenant-name')
                : application.tenant_3_name
                  ? application.tenant_3_name
                  : 'No Data'
            }
          />
          <DetailsCard
            title="Resident 4"
            value={
              isDemo
                ? getDemoData('tenant-name')
                : application.tenant_4_name
                  ? application.tenant_4_name
                  : 'No Data'
            }
          />
        </RowContainer>

        <RowContainer>
          <DetailsCard
            title="Resident 1 Portion of fees"
            value={
              application.tenant_1_portion_fee
                ? '$' +
                  (application.tenant_1_portion_fee
                    ? parseFloat(application.tenant_1_portion_fee).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
            width="20%"
          />
          <DetailsCard
            title="Resident 2 Portion of fees"
            value={
              application.tenant_2_name
                ? '$' +
                  (application.tenant_2_portion_fee
                    ? parseFloat(application.tenant_2_portion_fee).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
            width="20%"
          />

          <DetailsCard
            title="Resident 3 Portion of fees"
            value={
              application.tenant_3_name
                ? '$' +
                  (application.tenant_3_portion_fee
                    ? parseFloat(application.tenant_3_portion_fee).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
            width="20%"
          />

          <DetailsCard
            title="Resident 4 Portion of fees"
            value={
              application.tenant_4_name
                ? '$' +
                  (application.tenant_4_portion_fee
                    ? parseFloat(application.tenant_4_portion_fee).toLocaleString('en-US')
                    : 0)
                : 'No Data'
            }
            width="20%"
          />
        </RowContainer>
      </DetailsContainer>
    </Box>
  );
};

const DetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (max-width: ${(props) => props.theme.md}) {
    flex-direction: row;
  }
`;

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  & > div {
    width: 25%;
  }

  @media screen and (max-width: ${(props) => props.theme.md}) {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }
`;
